const store = window.localStorage;
export const AUTH_TOKEN_KEY = "auth-token";
export const REFRESH_TOKEN_KEY = "refresh-token";
export const KEEP_SIGNED_IN_KEY = "keep-signed-in";
export const AUTH_LOCKED_KEY = "auth-storage-locked";

export function getItem(key) {
  return store.getItem(key);
}

export function setItem(key, value) {
  store.setItem(key, value);
}

export function removeItem(key) {
  store.removeItem(key);
}

export function clear() {
  store.clear();
}
